<template>
	<div>
		<el-dialog  :close-on-click-modal="false" title="图片管理 " :visible.sync="imageModel" width="80%" top="5vh">

			<el-container style="position: relative;height: 70vh;margin: -30px -20px;" v-loading="loading">
				<el-header class="d-flex align-items-center border-bottom">
					<!-- 头部 -->
					<div class="d-flex mr-auto ">
						<el-select v-model="searchFrom.order" placeholder="請選擇活动区域" size="medium" class="mr-2" style="width: 150px;">
							<el-option label="降序" value="desc"></el-option>
							<el-option label="升序" value="asc"></el-option>
						</el-select>
						<el-input placeholder="輸入图片名稱" class="mr-2" v-model="searchFrom.keyword" style="width: 150px;" size="medium"></el-input>
						<el-button type="success" size="medium" @click="getImageList">搜索</el-button>
					</div>

				</el-header>
				<el-container>
					<el-aside class="bg-white border-right" width="200px" style="position: absolute;top:60px;bottom: 60px;left: 0;">
						<!-- 侧边 | 相册列表 -->
						<ul class="list-group list-group-flush">
							<album-item v-for="(item,index) in albums" :key="index" :item="item" :index="index" :active="albumIndex===index"
							 @change="albumChange" :showOption="false"></album-item>
						</ul>
					</el-aside>
					<el-container>
						<el-main style="position: absolute;top:60px;bottom: 60px;left: 200px;right: 0;">
							<!-- 主内容 -->
							<el-row :gutter="10">
								<el-col :span="24" :lg="4" :md="6" :sm="8" v-for="(item,index) in imageList" :key="index">
									<el-card class="box-card mb-3 position-relative" shadow="hover" style="cursor: pointer;" :body-style="{'padding':'0'}">

										<div class="border" :class="{'border-danger':item.ischeck}">

											<span class="badge badge-danger" v-if="item.ischeck" style="position: absolute;right: 0;top: 0;">{{item.checkOrder}}</span>
											<el-image @click="choose(item)" style="width: 100%; height: 100px" :src="item.url" fit="cover"></el-image>
											<!-- <img @click="choose(item)" :src="item.url" class="w-100" style="height: 100px;" alt=""> -->
											<div class="w-100 text-white px-1" style="background-color: rgba(0,0,0,0.5);margin-top: -25px;position: absolute;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 1;overflow: hidden;">
												<span class="small">{{item.name}}</span>
											</div>

											<div class="p-2 text-center">
												<el-button-group>
													<el-button @click="previewImage(item)" size="mini" class="p-2" icon="el-icon-view"></el-button>
													<!-- <el-button @click="imageEdit(item,index)" size="mini" class="p-2" icon="el-icon-edit"></el-button>
													<el-button @click="imageDel({index})" size="mini" class="p-2" icon="el-icon-delete"></el-button> -->
												</el-button-group>
											</div>
										</div>

									</el-card>
								</el-col>
							</el-row>
						</el-main>

					</el-container>
				</el-container>
				<el-footer class="d-flex border-top align-items-center px-0">
					<!-- 底部 -->
					<div style="width: 200px;flex-shrink: 0;" class="h-100 d-flex align-items-center justify-content-center border-right">
						<el-button-group>
							<el-button-group>
								<el-button :disabled="albumPage===1" size="mini" icon="el-icon-arrow-left" @click="changeAlbumPage('pre')">上一页</el-button>
								<el-button size="mini" @click="changeAlbumPage('next')" :disabled="albumPage === Math.ceil(albumsTotal/20)">下一页<i
									 class="el-icon-arrow-right el-icon--right"></i></el-button>
							</el-button-group>
						</el-button-group>
					</div>
					<div style="flex: 1;" class="px-2">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
						</el-pagination>
					</div>
				</el-footer>
			</el-container>

			<div slot="footer" class="dialog-footer">
				<el-button @click="hide">取 消</el-button>
				<el-button type="primary" @click="confirm">確 定</el-button>
			</div>
		</el-dialog>


		<!-- 预览图片 -->
		<el-dialog  :close-on-click-modal="false" :visible.sync="previewModel" width="50vw" top="5vh">
			<div style="margin: -60px -20px -30px -20px;">
				<img :src="previewUrl" class="w-100" alt="">

			</div>
		</el-dialog>
	</div>



</template>

<script>
	import albumItem from '@/components/image/album-item.vue';
	export default {
		props: {
			max: {
				type: Number,
				default: 9
			},
		},
		components: {
			albumItem
		},
		data() {
			return {
				previewUrl: "",
				radio: 3,
				imageModel: false,
				callback: false,
				currentPage: 1,
				imageList: [],
				searchFrom: {
					order: 'desc',
					keyword: ''
				},
				albumPage: 1,
				albumIndex: 0,
				albums: [],
				// 选中數据 
				chooseList: [],
				pageSize: 10,
				pageSizes: [10, 20, 50, 100],
				total: 400,
				albumsTotal: 0,
				loading: false,
				previewModel: false
			}
		},
		computed: {
			imageClassId() {
				let item = this.albums[this.albumIndex]
				if (item) {
					return item.id
				}
				return 0
			}
		},
		created() {
			//初始化用戶信息
			this.$store.commit('initUser');
			// 初始化後台菜單
			this.$store.commit('initNavBar')
			//this.__init()
		},
		methods: {
			// 相册分页
			changeAlbumPage(type) {
				if (type === 'pre') {
					this.albumPage--
				} else {
					this.albumPage++
				}
				//this.__init()
			},
			chooseImage(callback) {
				// 取消选中
				this.unChoose()
				this.callback = callback
				this.imageModel = true;
			},
			getImageList() {
				this.loading = true;
				this.axios.post('/admin/image/imgList', {
					id: this.imageClassId,
					page: this.currentPage,
					limit: this.pageSize,
					sort: this.searchFrom.order,
					search: this.searchFrom.keyword
				}, {
					token: true,
					loading: true
				}).then(res2 => {

					let list2 = res2.data;

					if (list2.code == 1) {
						let data = list2.data.list
						this.imageList = data.list.map(item => {
							return {
								id: item.id,
								name: item.name,
								url: item.url,
								ischeck: false,
								checkOrder: 0
							}
						})
						this.total = data.total
					}
					this.loading = false;
				}).catch(error => {
					this.loading = false;
				})
			},
			// 预览图片
			previewImage(item) {
				this.previewUrl = item.url
				this.previewModel = true
			},
			// 點擊確定
			confirm() {
				if (typeof this.callback === 'function') {
					this.callback(this.chooseList)
				}
				// 选中的图片

				// 隐藏
				this.hide()
			},
			hide() {

				this.imageModel = false;
				this.callback = false
			},
			chaneges(e) {
				console.log(e);
			},
			__init() {
				let token = window.sessionStorage.getItem('token')
				if(!token){
					return;
				}
				this.loading = true;
				this.axios.post('/admin/image/classList', {
					page: this.albumPage
				}, {
					token: true,
					loading: true
				}).then(res => {
					let list = res.data;
					//console.log(list)
					if (list.code == 1) {
						this.albums = list.data.list.list
						this.albumsTotal = list.data.list.total
						this.getImageList()
					}

				}).catch(err => {
					// 失敗
					console.log(err);
					this.loading = false;
				})

			},
			//取消选中
			unChoose() {
				//找到所有选中的图片
				this.imageList.forEach(img => {
					let i = this.chooseList.findIndex(item => {
						return item.id === img.id
					})
					if (i > -1) {
						// 取消选中样式
						img.ischeck = false
						// 排序重置
						img.checkOrder = 0
						// 从chooselist中移除
						this.chooseList.splice(i, 1)
					}
				})



			},
			// 删除當前图片
			imageDel(obj) {
				this.$confirm(obj.all ? '是否批量删除选中的图片' : '是否删除该图片?', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (obj.all) {
						// 批量删除
						let list = this.imageList.filter(img => {
							// 对比chooselist，如果不存在则return
							//return !this.chooseList.some(c=>c.id === img.id)  //簡化写法
							return !this.chooseList.some(c => {
								return c.id === img.id
							})
						})
						this.imageList = list
						this.chooseList = []
					} else {
						// 單独删除
						this.imageList.splice(obj.index, 1)
					}

					this.$message({
						message: '删除成功',
						type: 'success'
					});
				})

			},
			// 批量删除(无用，展示)
			imgDelAll() {
				// 遍历imagelist
				let list = this.imageList.filter(img => {
					// 对比chooselist，如果不存在则return
					//return !this.chooseList.some(c=>c.id === img.id)  //簡化写法
					return !this.chooseList.some(c => {
						return c.id === img.id
					})
				})
				this.imageList = list
				this.chooseList = []
			},
			// 选中图片
			choose(item) {

				if (!item.ischeck) {
					// 限制选中數量
					if (this.chooseList.length >= this.max) {
						return this.$message({
							message: '最多可选张' + this.max + '图片',
							type: 'warning'
						});
					}
					// 加入选中
					this.chooseList.push({
						id: item.id,
						url: item.url
					})
					//item.ischeck = !item.ischeck
					//计算序號 
					item.checkOrder = this.chooseList.length
					// 修改狀態
					item.ischeck = true
					return;
				}
				// 取消选中
				// 找到在chooseList中的索引
				let i = this.chooseList.findIndex(v => v.id === item.id)
				//console.log(i);
				if (i === -1) return;
				// 重新计算序號
				let length = this.chooseList.length
				// 取消选中中間部分
				if (i + 1 < length) {
					// 重新计算imagelist中的序號
					for (let j = i; j < length; j++) {
						let no = this.imageList.findIndex(v => v.id === this.chooseList[j].id)
						if (no > -1) {
							this.imageList[no].checkOrder--
						}
					}
				}
				// 删除
				this.chooseList.splice(i, 1)
				// 修改狀態
				item.ischeck = false
				// 重置序號
				item.checkOrder = 0
			},


			// 修改图片
			imageEdit(item, index) {
				this.$prompt('請輸入新名稱', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					inputValue: item.name,
					inputValidator(val) {
						if (val === '') {
							return '图片名稱不能为空'
						}
					}
				}).then(({
					value
				}) => {
					item.name = value
					this.$message({
						message: '修改成功',
						type: 'success'
					});
				})
			},

			// 切换相册
			albumChange(index) {
				this.albumIndex = index;
				this.getImageList()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.getImageList()
				//console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getImageList()
				//console.log(`當前页: ${val}`);
			},




		}
	}
</script>

<style>
</style>
